import { useSelector, useDispatch } from "react-redux";
import { Tabs } from "antd";
import { findMenuItem } from "../../utils/generalUtils";

import "../../styles/components/selectComponent/tabSelection.scss";

const TabSelection = ({
  menuItems,
  currentTabKey,
  setTabAction,
  defaultComponent,
}) => {
  const dispatch = useDispatch();
  const currentTab = useSelector((state) => state.generalSlice[currentTabKey]);

  const handleTabChange = (key) => {
    dispatch(setTabAction(key));
  };

  // const [hoveredTabKey, setHoveredTabKey] = useState(null);

  const renderContent = () => {
    const activeItem = findMenuItem(menuItems, currentTab);
    return activeItem
      ? activeItem.component
      : defaultComponent || <p>Page not found</p>;
  };

  return (
    <div className="tab-selection-container">
      <Tabs
        // type="card"
        tabBarGutter={0}
        size="large"
        activeKey={currentTab}
        onChange={handleTabChange}
        indicator={{ size: (origin) => origin - 30, align: "center" }}
        items={menuItems.map((item) => ({
          key: item.key,
          label: (
            <div className="tabs-label">
              <span style={{ fontSize: "17px" }}>{item.icon}</span>
              <span>{item.label}</span>
            </div>
          ),
        }))}
        className="tab-selection-tabs"
      />
      <div className="tab-selection-content">{renderContent()}</div>
    </div>
  );
};

export default TabSelection;
